// extracted by mini-css-extract-plugin
export var modal = "_eg-0";